import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "report_users",
    object: "report_user",
    header: [
      { text: "Usuario", value: "sender_id" },
      { text: "Usuario Reportado", value: "receiver_id" },
      { text: "Motivo", value: "reason" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["_id"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
